<script setup>
import { computed } from "vue";

const seedValue = Math.floor(Math.random() * 100000);

const viewBoxWidth = 25;
const viewBoxHeight = 24;
const aspectRatio = viewBoxWidth / viewBoxHeight;

const props = defineProps({
  size: {
    type: Number,
  },
  width: {
    type: Number,
  },
  height: {
    type: Number,
  },
  color: {
    type: String,
    default: "currentColor",
  },
});

const svgWidth = computed(() => props.size ?? props.width ?? viewBoxWidth);
const svgHeight = computed(() => {
  if (props.height) {
    return props.height;
  }
  return (props.size ?? viewBoxWidth) / aspectRatio;
});

const maskId = computed(() => `search-icon-mask-${seedValue}`);
</script>
<template>
  <svg :width="svgWidth" :height="svgHeight" :viewBox="`0 0 ${viewBoxWidth} ${viewBoxHeight}`" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      :id="maskId"
      style="mask-type: alpha;"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      :width="viewBoxWidth"
      :height="viewBoxHeight"
    >
      <rect x="0.5" :width="viewBoxWidth" :height="viewBoxHeight" fill="#D9D9D9" />
    </mask>
    <g :mask="`url(#${maskId})`">
      <path
        d="M20.0445 20.5751L13.7638 14.2941C13.2638 14.7069 12.6887 15.03 12.0387 15.2633C11.3887 15.4966 10.7163 15.6133 10.0215 15.6133C8.31233 15.6133 6.86583 15.0216 5.682 13.8381C4.49817 12.6546 3.90625 11.2084 3.90625 9.49956C3.90625 7.7909 4.498 6.34423 5.6815 5.15956C6.865 3.97506 8.31117 3.38281 10.02 3.38281C11.7287 3.38281 13.1753 3.97473 14.36 5.15856C15.5445 6.3424 16.1368 7.7889 16.1368 9.49806C16.1368 10.2122 16.0169 10.8943 15.7773 11.5443C15.5374 12.1943 15.2175 12.7596 14.8175 13.2403L21.0983 19.5211L20.0445 20.5751ZM10.0215 14.1136C11.31 14.1136 12.4013 13.6664 13.2955 12.7721C14.1898 11.8779 14.637 10.7866 14.637 9.49806C14.637 8.20956 14.1898 7.11823 13.2955 6.22406C12.4013 5.32973 11.31 4.88256 10.0215 4.88256C8.733 4.88256 7.64167 5.32973 6.7475 6.22406C5.85317 7.11823 5.406 8.20956 5.406 9.49806C5.406 10.7866 5.85317 11.8779 6.7475 12.7721C7.64167 13.6664 8.733 14.1136 10.0215 14.1136Z"
        :fill="color"
      />
    </g>
  </svg>
</template>
